import script from "./addWhiteListManage.vue?vue&type=script&setup=true&lang=js"
export * from "./addWhiteListManage.vue?vue&type=script&setup=true&lang=js"

import "./addWhiteListManage.vue?vue&type=style&index=0&id=75726214&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75726214"]])

export default __exports__